import { t } from "i18next";
import React, { useEffect, useState } from "react";
import logo1 from "../assets/logos/01.webp";
import logo2 from "../assets/logos/02.webp";
import logo3 from "../assets/logos/03.webp";
import logo4 from "../assets/logos/04.webp";
import logo5 from "../assets/logos/05.webp";
import logo6 from "../assets/logos/06.webp";
import logo7 from "../assets/logos/07.webp";
import logo8 from "../assets/logos/08.webp";
import logo9 from "../assets/logos/09.webp";
import logo10 from "../assets/logos/10.webp";
import logo11 from "../assets/logos/11.webp";
import logo12 from "../assets/logos/12.webp";
import logo13 from "../assets/logos/13.webp";
import logo14 from "../assets/logos/14.webp";
import logo15 from "../assets/logos/15.webp";
import logo16 from "../assets/logos/16.webp";
import logo17 from "../assets/logos/17.webp";
import logo18 from "../assets/logos/18.webp";
import logo19 from "../assets/logos/19.webp";
import logo20 from "../assets/logos/20.webp";
import Marquee from "react-fast-marquee";

const data = [
  {
    logo: logo1,
    name: "مطعم عزمي",
  },
  {
    logo: logo2,
    name: "Innovation Medical Equipment",
  },
  {
    logo: logo3,
    name: "مصنع لقلاق المتميز للصناعة",
  },
  {
    logo: logo4,
    name: "مبادرة إبتسامة",
  },
  {
    logo: logo5,
    name: "Touq Media Co",
  },
  {
    logo: logo6,
    name: "Vasa Flower",
  },
  {
    logo: logo7,
    name: "Pastel",
  },
  {
    logo: logo8,
    name: "بتيل لللإستشارات الهندسية",
  },
  {
    logo: logo9,
    name: "مدارس الخوالد الأهلية",
  },
  {
    logo: logo10,
    name: "أصل اللقيمات",
  },
  {
    logo: logo11,
    name: "لولز",
  },
  {
    logo: logo12,
    name: "فش واصل",
  },
  {
    logo: logo13,
    name: "لؤلؤة الأربش للمجوهرات",
  },
  // {
  //   logo: logo14,
  //   name: "عزمي",
  // },
  {
    logo: logo15,
    name: "الهيئة الملكية للجبيل و ينبع",
  },
  {
    logo: logo16,
    name: "حاشي باشا",
  },
  {
    logo: logo17,
    name: "مؤسسة اتحاد المسك للمقاولات",
  },
  {
    logo: logo18,
    name: "Qadsiah FC",
  },
  {
    logo: logo19,
    name: "Amigo Burger",
  },
  {
    logo: logo20,
    name: "Hemaia",
  },
];

export const Testimonials = (props) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile(); // Run on mount
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <div id="testimonials">
      <div>
        <div className="section-title text-center">
          <h2>{t("our-clients")}</h2>
        </div>
        <Marquee
          style={{
            overflowY: "hidden",
            userSelect: "none",
          }}
          pauseOnHover
          gradient={!isMobile} // Disable gradient on mobile
          gradientColor={[246, 246, 246]} // Correct gradient color format
        >
          {data.map((d, i) => (
            <div key={`${d.name}-${i}`} className="client">
              <div className="testimonial">
                <div className="testimonial-image">
                  <img
                    style={{
                      pointerEvents: "none",
                    }}
                    src={d.logo}
                    alt={d.name}
                    loading="lazy"
                  />
                  <div className="testimonial-meta"> {d.name} </div>
                </div>
              </div>
            </div>
          ))}
        </Marquee>
      </div>
    </div>
  );
};
